import type { CategoryPanelProps } from "../../types/category-panel";
import { CategoryPanelClassic } from "./variants/CategoryPanelClassic";
import { CategoryPanelModern } from "./variants/CategoryPanelModern";

/**
 * Painel de categorias — resolve a variante pelo layout do portal
 * (highlights.categoryLayout):
 *  - "classico" (default) → mega-menu (dropdown/accordion)
 *  - "moderno" → drawer lateral + popover
 */
export function CategoryPanel({ layout = "classico", ...props }: CategoryPanelProps) {
    if (layout === "moderno") return <CategoryPanelModern {...props} />;
    return <CategoryPanelClassic {...props} />;
}
// nota: `anchorClassName` só afeta a variante clássica (mega-menu desktop).
